import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { PageTabs } from '@components/page-tabs';
import { links } from '../core/router';

const pageTabs = [
    { label: 'Catalog', id: 'catalog' },
    { label: 'Purchases', id: 'purchases' }
];

export const VoucherVendors = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const showTabs = /^\/vendors(\/purchases)?\/?$/.test(pathname);
    const tab = pathname.startsWith('/vendors/purchases') ? 1 : 0;

    const changePage = (value: number) => {
        if (value === 0) {
            navigate(links.vendor());
            return;
        }
        navigate(links.voucherPurchases());
    };

    return (
        <>
            {showTabs && (
                <div className="mb-6">
                    <PageTabs
                        tabs={pageTabs}
                        value={tab}
                        onChange={changePage}
                    />
                </div>
            )}
            <Outlet />
        </>
    );
};
